import { generateUtilityClass, generateUtilityClasses } from '../styles/classes';
export var toastComponentName = 'QuantumToast';
export function getToastUtilityClass(slot) {
    return generateUtilityClass(toastComponentName, slot);
}
export var toastClasses = generateUtilityClasses(toastComponentName, ['root', 'alert']);
